import axios from "axios";
import bbox from "@turf/bbox";
import points_within_polygon from "@turf/points-within-polygon";
import intersect from "@turf/intersect";
import calculate_area from "@turf/area";
import geojson_geometries_lookup from "geojson-geometries-lookup";

import {
  get_quota_access,
  get_quota_access_sini_ai,
  get_quota_ai_chat,
} from "./authActions";
import { fly_init_update } from "./sini_v2";
import { create_ai_sini_sheet } from "./ai_excel";
import { compress_sini } from "../validation/compress_sini";
import grid_functions from "../validation/grid_functions";
import { bun_server } from "./baseUrl";

const { get_grids_in_bounding_box_and_grouping } = grid_functions;

const delta_larger = 0.02;
// const delta_larger = 0.03; -- kegedean yg bagian flood, jadi timeout
// const delta_larger = 0.05;
//0.02 - di bogor deket gunung ga muncul desa di titik itu
//0.05 - masalah di atas solved

const delta_small = 0.01;
//0.003 - di kab bandung tidak muncul
//0.006 - mulai aman
//0.009 - lebih aman
//0.01 - paling aman, simplify angka

const grouping_number = 10;
const keys_float = [
  "PERTUMBUHAN PENDUDUK TAHUN 2020 (%)",
  "PERTUMBUHAN PENDUDUK TAHUN 2021 (%)",
  "PERTUMBUHAN PENDUDUK TAHUN 2022 (%)",
  "PERTUMBUHAN PENDUDUK TAHUN 2023 (%)",
  "PERTUMBUHAN PENDUDUK TAHUN 2024 (%)",
];

const keys_interger = [
  "JUMLAH PENDUDUK 2020",
  "JUMLAH PENDUDUK 2021",
  "JUMLAH PENDUDUK 2022",
  "JUMLAH PENDUDUK 2023",
  "JUMLAH PENDUDUK 2024",
  "KEPADATAN PENDUDUK 2020",
  "KEPADATAN PENDUDUK 2021",
  "KEPADATAN PENDUDUK 2022",
  "KEPADATAN PENDUDUK 2023",
  "KEPADATAN PENDUDUK 2024",
  "LAHIR TAHUN 2020",
  "LAHIR TAHUN 2021",
  "LAHIR TAHUN 2022",
  "LAHIR TAHUN 2023",
  "LAHIR TAHUN 2024",
  "ISLAM",
  "KRISTEN",
  "KATHOLIK",
  "HINDU",
  "BUDDHA",
  "KONGHUCU",
  "KEPERCAYAAN TERHADAP TUHAN YME",
  "LAKI-LAKI",
  "PEREMPUAN",
  "BELUM KAWIN",
  "KAWIN",
  "CERAI HIDUP",
  "CERAI MATI",
  "USIA 0-4",
  "USIA 5-9",
  "USIA 10-14",
  "USIA 15-19",
  "USIA 20-24",
  "USIA 25-29",
  "USIA 30-34",
  "USIA 35-39",
  "USIA 40-44",
  "USIA 45-49",
  "USIA 50-54",
  "USIA 55-59",
  "USIA 60-64",
  "USIA 65-69",
  "USIA 70-74",
  "USIA 75 TAHUN KE ATAS",
  "USIA PENDIDIKAN 3-4 TAHUN",
  "USIA PENDIDIKAN 5 TAHUN",
  "USIA PENDIDIKAN 12-14 TAHUN",
  "USIA PENDIDIKAN 15-17 TAHUN",
  "USIA PENDIDIKAN 18-22 TAHUN",
  "TIDAK/BELUM SEKOLAH",
  "BELUM TAMAT SD",
  "TAMAT SD",
  "SLTP",
  "SLTA",
  "D1 DAN D2",
  "D3",
  "S1",
  "S2",
  "S3",
  "GOLONGAN DARAH A",
  "GOLONGAN DARAH A+",
  "GOLONGAN DARAH A-",
  "GOLONGAN DARAH B",
  "GOLONGAN DARAH B+",
  "GOLONGAN DARAH B-",
  "GOLONGAN DARAH O",
  "GOLONGAN DARAH O+",
  "GOLONGAN DARAH O-",
  "GOLONGAN DARAH AB",
  "GOLONGAN DARAH AB+",
  "GOLONGAN DARAH AB-",
  "GOLONGAN DARAH TIDAK DIKETAHUI",
  "BELUM/TIDAK BEKERJA",
  "NELAYAN",
  "PELAJAR DAN MAHASISWA",
  "PENSIUNAN",
  "PERDAGANGAN",
  "MENGURUS RUMAH TANGGA",
  "WIRASWASTA",
  "GURU",
  "PERAWAT",
  "PENGACARA",
  "PEKERJAAN LAINNYA",
  "LUAS WILAYAH (KM²)",
  "JUMLAH KK",
  "PERPINDAHAN PENDUDUK",
  "JUMLAH MENINGGAL",
  "PERUBAHAN DATA",
  "JUMLAH WAJIB KTP",
  "JUMLAH REKAM WAJIB KTP",
];

/**
 * @route : get_sini_data
 * @endpoint : /sini_v2/get_sini_data
 * @methode : get (multiple)
 * @params : lat, long, request_id, sini_data_mode, show_survey_1, is_from_excel, geo_layer_id, feature_key, field_key,
 * @body : -
 */
export const get_sini_data = (params, from) => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "sini_load_parent",
    });

    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    dispatch(fly_init_update());

    let json_db = {};
    let sini_object = {};
    let summary_sini = "";
    let KABKOT, PROVINSI;
    let action_array = [];
    let geojson_polygon_isochrone = {};
    let title_1 = "Untitled";
    let title_2 = "Untitled";

    const {
      lat,
      long,
      request_id,
      sini_data_mode,
      show_survey_1,
      is_from_excel,
      geo_layer_id,
      feature_key,
      field_key,
    } = params;
    let { km_rad } = params;

    const state = getState();
    let { request_id_active_array } = state.sini;
    if (!request_id_active_array.includes(request_id)) {
      request_id_active_array.push(request_id);
    } else {
      request_id_active_array = request_id_active_array.filter(
        (item) => item !== request_id
      );
    }
    dispatch({
      type: "set_value_sini",
      payload: {
        key: "request_id_active_array",
        value: request_id_active_array,
      },
    });

    dispatch({
      type: "set_value_sini",
      payload: {
        key: "coordinates_loading",
        value: [long, lat],
      },
    });
    dispatch({
      type: "set_value_sini",
      payload: {
        key: "sini_marker_active",
        value: params,
      },
    });

    if (sini_data_mode === "sini_general") {
      action_array = [
        "demography_list",
        "landvalue",
        "landzone",
        "poi_property_2025",
        "flood",
        "landslide",
        "tsunami",
        "poi",
        "rdtr",
      ];
      if (show_survey_1) {
        action_array.push("poi_survey_1_features");
      }
    } else {
      title_1 = "RDTR";
      action_array = ["rdtr"];
    }
    dispatch({
      type: "set_value_sini",
      payload: {
        key: "total_step",
        value: action_array.length,
      },
    });
    km_rad = km_rad || 1;

    const sini_init = {
      request_id,
      lat,
      long,
      km_rad,
    };
    dispatch({
      type: "push_value_sini",
      payload: {
        key: "ai_parent_list",
        value: [sini_init],
      },
    });
    dispatch({
      type: "push_value_sini",
      payload: {
        key: "ai_parent_detail_list",
        value: [sini_init],
      },
    });
    dispatch({
      type: "push_value_sini",
      payload: {
        key: "ai_parent_child_list",
        value: [sini_init],
      },
    });
    dispatch({
      type: "set_value_sini",
      payload: {
        key: "request_id_active",
        value: request_id,
      },
    });
    dispatch({
      type: "set_value_sini",
      payload: {
        key: "request_id_loading",
        value: request_id,
      },
    });

    dispatch({
      type: "edit_inside_array_sini",
      payload: {
        key: "ai_parent_detail_list",
        id_key_parent: "request_id",
        id_value_parent: request_id,
        id_key_child: "title_1",
        value_child: title_1,
      },
    });

    const isochrone_mode = "driving"; //Isochrone API Profiles: driving, driving-traffic, walking, cycling
    const contours_minutes = 10;
    const contours_meters = 10;
    const contours_type = "minutes";
    let isochrone_url;

    if (contours_type === "minutes") {
      isochrone_url = `https://api.mapbox.com/isochrone/v1/mapbox/${isochrone_mode}/${long}%2C${lat}?contours_minutes=${contours_minutes}&polygons=true&denoise=1&access_token=${process.env.REACT_APP_MAPBOX_API_KEY}`;
    } else {
      isochrone_url = `https://api.mapbox.com/isochrone/v1/mapbox/${isochrone_mode}/${long}%2C${lat}?contours_meters=${contours_meters}&polygons=true&denoise=1&access_token=${process.env.REACT_APP_MAPBOX_API_KEY}`;
    }
    const res_isokron = await axios.get(isochrone_url);
    geojson_polygon_isochrone = res_isokron?.data || {
      type: "FeatureCollection",
      features: [],
    };

    if (res_isokron?.data?.features?.[0]?.properties) {
      geojson_polygon_isochrone.features[0].properties = {
        ...geojson_polygon_isochrone.features[0].properties,
        isochrone_mode,
        contours_minutes,
        contours_meters,
        contours_type,
      };
    }

    dispatch({
      type: "edit_inside_array_sini",
      payload: {
        key: "ai_parent_detail_list",
        id_key_parent: "request_id",
        id_value_parent: request_id,
        id_key_child: "geojson_polygon_isochrone",
        value_child: geojson_polygon_isochrone,
      },
    });
    sini_object.geojson_polygon_isochrone = geojson_polygon_isochrone;
    json_db.geojson_polygon_isochrone = geojson_polygon_isochrone;

    const min_long_small = long - delta_small;
    const min_lat_small = lat - delta_small;
    const max_long_small = long + delta_small;
    const max_lat_small = lat + delta_small;
    const [min_long_fit, min_lat_fit, max_long_fit, max_lat_fit] = bbox(
      geojson_polygon_isochrone
    );

    let [min_long_larger, min_lat_larger, max_long_larger, max_lat_larger] =
      bbox(geojson_polygon_isochrone);
    min_long_larger -= delta_larger;
    min_lat_larger -= delta_larger;
    max_long_larger += delta_larger;
    max_lat_larger += delta_larger;

    const feature_isochrone = geojson_polygon_isochrone?.features?.[0];

    const delay_constant = 0;
    const delay_promise = () =>
      new Promise((res) => setTimeout(res, delay_constant));
    const parent_function = () => {
      return action_array.reduce(
        (last_promise, object, idx) =>
          last_promise.then((result_sum) =>
            child_function(object, idx).then((result_current) => [
              ...result_sum,
              result_current,
            ])
          ),
        Promise.resolve([])
      );
    };

    const child_function = async (item, idx) => {
      return delay_promise().then(() => {
        const core_function = async () => {
          try {
            dispatch({
              type: "set_value_sini",
              payload: {
                key: "current_step",
                value: idx + 1,
              },
            });
            dispatch({
              type: "set_value_sini",
              payload: {
                key: "current_topic_loading",
                value: item,
              },
            });
            dispatch({
              type: "set_loading_action",
              payload: item,
            });

            if (item === "poi") {
              let res, data;
              res = await axios.get(
                bun_server +
                  `/sini_v2/${item}?lat=${lat}&long=${long}&min_long=${min_long_fit}&min_lat=${min_lat_fit}&max_long=${max_long_fit}&max_lat=${max_lat_fit}`,
                config
              );
              data = res?.data || [];
              const geojson_point = {
                type: "FeatureCollection",
                features: data,
              };
              const geojson_point_filtered = await points_within_polygon(
                geojson_point,
                geojson_polygon_isochrone
              );
              data = geojson_point_filtered?.features || [];

              let poi_features = [];
              let poi_resume_1 = [];
              let poi_resume_2 = [];
              let poi_resume_3 = [];

              data = data.map((feature) => {
                const TIPE_1 = feature?.properties?.TIPE_1 || "-";
                const TIPE_2 = feature?.properties?.TIPE_2 || "-";
                const TIPE_3 = feature?.properties?.TIPE_3 || "-";
                feature.properties.TIPE_1 = TIPE_1;
                feature.properties.TIPE_2 = TIPE_2;
                feature.properties.TIPE_3 = TIPE_3;
                return feature;
              });

              data.forEach((feature) => {
                const name_tipe_1 = feature?.properties?.TIPE_1;
                const name_tipe_2 = feature?.properties?.TIPE_2;
                const name_tipe_3 = feature?.properties?.TIPE_3;

                // TIPE 1
                let number_tipe_1 = 0;
                let index_tipe_1 = poi_resume_1.findIndex(
                  (item) => item.name === name_tipe_1
                );
                if (index_tipe_1 === -1) {
                  poi_resume_1.push({ name: name_tipe_1, number: 1 });
                } else {
                  number_tipe_1 = poi_resume_1[index_tipe_1].number + 1;
                  poi_resume_1[index_tipe_1].number = number_tipe_1;
                }

                // TIPE 2
                let number_tipe_2 = 0;
                let index_tipe_2 = poi_resume_2.findIndex(
                  (item) =>
                    item.name === name_tipe_2 && item.parent === name_tipe_1
                );
                if (index_tipe_2 === -1) {
                  poi_resume_2.push({
                    name: name_tipe_2,
                    parent: name_tipe_1,
                    number: 1,
                  });
                } else {
                  number_tipe_2 = poi_resume_2[index_tipe_2].number + 1;
                  poi_resume_2[index_tipe_2].number = number_tipe_2;
                }

                // TIPE 3
                let number_tipe_3 = 0;
                let index_tipe_3 = poi_resume_3.findIndex(
                  (item) =>
                    item.name === name_tipe_3 &&
                    item.parent_tipe_2 === name_tipe_2 &&
                    item.parent_tipe_1 === name_tipe_1
                );
                if (index_tipe_3 === -1) {
                  poi_resume_3.push({
                    name: name_tipe_3,
                    parent_tipe_2: name_tipe_2,
                    parent_tipe_1: name_tipe_1,
                    number: 1,
                  });
                } else {
                  number_tipe_3 = poi_resume_3[index_tipe_3].number + 1;
                  poi_resume_3[index_tipe_3].number = number_tipe_3;
                }
              });

              poi_features = [...poi_features, ...data];

              dispatch({
                type: "push_inside_array_sini",
                payload: {
                  key: "ai_parent_detail_list",
                  id_key_parent: "request_id",
                  id_value_parent: request_id,
                  id_key_child: "poi_features",
                  value_array: data,
                },
              });

              sini_object.poi_resume_1 = poi_resume_1;
              sini_object.poi_resume_2 = poi_resume_2;
              sini_object.poi_resume_3 = poi_resume_3;

              dispatch({
                type: "edit_inside_array_sini",
                payload: {
                  key: "ai_parent_detail_list",
                  id_key_parent: "request_id",
                  id_value_parent: request_id,
                  id_key_child: "poi_resume_1",
                  value_child: poi_resume_1,
                },
              });
              dispatch({
                type: "edit_inside_array_sini",
                payload: {
                  key: "ai_parent_detail_list",
                  id_key_parent: "request_id",
                  id_value_parent: request_id,
                  id_key_child: "poi_resume_2",
                  value_child: poi_resume_2,
                },
              });
              dispatch({
                type: "edit_inside_array_sini",
                payload: {
                  key: "ai_parent_detail_list",
                  id_key_parent: "request_id",
                  id_value_parent: request_id,
                  id_key_child: "poi_resume_3",
                  value_child: poi_resume_3,
                },
              });

              dispatch({
                type: "state_update",
              });
              /*POI json_db*/
              const poi_features_id = poi_features.map((item) => item._id);
              json_db.poi_features = poi_features_id;
              json_db.poi_resume_1 = poi_resume_1;
              json_db.poi_resume_2 = poi_resume_2;
              json_db.poi_resume_3 = poi_resume_3;
            } else if (item === "poi_survey_1_features") {
              //get manifest layer
              const res_manifest_survey_1 = await axios.get(
                bun_server + "/sini_v2/get_manifest_survey_1",
                config
              );
              const manifest_survey_1 = res_manifest_survey_1.data;
              const res = await axios.get(
                bun_server +
                  `/sini_v2/${item}?lat=${lat}&long=${long}&min_long=${min_long_fit}&min_lat=${min_lat_fit}&max_long=${max_long_fit}&max_lat=${max_lat_fit}`,
                config
              );
              let data = res?.data || [];
              const geojson_point = {
                type: "FeatureCollection",
                features: data,
              };
              const geojson_point_filtered = await points_within_polygon(
                geojson_point,
                geojson_polygon_isochrone
              );
              data = geojson_point_filtered?.features || [];
              let poi_survey_1_features = [];
              let jenis_bangunan_resume = []; //array of object, {name, number}
              let average_sewa = 0;
              let min_sewa = Infinity; //set initial value to a very high number
              let max_sewa = -Infinity; //set initial value to a very low number
              let total_sewa = 0;
              let count_sewa = 0;
              if (data.length > 0) {
                const harga_key = "adaa7d32-31b9-4da8-a4c5-0a59c8b1642e";
                const jenis_bangunan_key =
                  "06abb286-5789-4f4b-ae15-0a9419c62a12";
                data.forEach((feature) => {
                  poi_survey_1_features.push(feature._id);
                  const name_tipe_1 = feature?.properties?.[jenis_bangunan_key];
                  let number_tipe_1 =
                    jenis_bangunan_resume.find(
                      (item) => name_tipe_1 === item.name
                    )?.number || 0;
                  number_tipe_1++;
                  let index_tipe_1 = jenis_bangunan_resume.findIndex(
                    (item) => name_tipe_1 === item.name
                  );
                  if (index_tipe_1 > -1) {
                    jenis_bangunan_resume[index_tipe_1].number = number_tipe_1;
                  } else {
                    jenis_bangunan_resume.push({
                      name: name_tipe_1,
                      number: number_tipe_1,
                    });
                  }
                  const value_sewa = parseFloat(
                    feature?.properties?.[harga_key]
                  );
                  if (!isNaN(value_sewa)) {
                    total_sewa += value_sewa;
                    count_sewa++;
                    if (value_sewa < min_sewa) min_sewa = value_sewa;
                    if (value_sewa > max_sewa) max_sewa = value_sewa;
                  }
                });
                if (count_sewa > 0)
                  average_sewa = parseInt(total_sewa / count_sewa);
              } else {
                min_sewa = 0;
                max_sewa = 0;
              }
              json_db.poi_survey_1_features = poi_survey_1_features;
              json_db.jenis_bangunan_resume = jenis_bangunan_resume;
              json_db.average_sewa = average_sewa;
              json_db.min_sewa = min_sewa;
              json_db.max_sewa = max_sewa;
              json_db.total_sewa = total_sewa;
              json_db.count_sewa = count_sewa;
              dispatch({
                type: "edit_inside_array_sini",
                payload: {
                  key: "ai_parent_detail_list",
                  id_key_parent: "request_id",
                  id_value_parent: request_id,
                  id_key_child: "poi_survey_1_features",
                  value_child: data,
                },
              });
              const object_survey_1 = {
                jenis_bangunan_resume,
                average_sewa,
                min_sewa,
                max_sewa,
                total_sewa,
                count_sewa,
                manifest_survey_1,
              };
              for (const key in object_survey_1) {
                dispatch({
                  type: "edit_inside_array_sini",
                  payload: {
                    key: "ai_parent_detail_list",
                    id_key_parent: "request_id",
                    id_value_parent: request_id,
                    id_key_child: key,
                    value_child: object_survey_1[key],
                  },
                });
              }
            } else if (item === "poi_property_2025") {
              let res, data;
              let poi_property_2025 = [];
              res = await axios.get(
                bun_server +
                  `/sini_v2/${item}?lat=${lat}&long=${long}&min_long=${min_long_fit}&min_lat=${min_lat_fit}&max_long=${max_long_fit}&max_lat=${max_lat_fit}`,
                config
              );
              data = res?.data?.poi_property_2025 || [];
              const geojson_point = {
                type: "FeatureCollection",
                features: data,
              };
              const geojson_point_filtered = await points_within_polygon(
                geojson_point,
                geojson_polygon_isochrone
              );
              poi_property_2025 = geojson_point_filtered?.features || [];
              dispatch({
                type: "edit_inside_array_sini",
                payload: {
                  key: "ai_parent_detail_list",
                  id_key_parent: "request_id",
                  id_value_parent: request_id,
                  id_key_child: "poi_property_2025",
                  value_child: poi_property_2025,
                },
              });
              /*POI json_db*/
              const poi_property_2025_id = poi_property_2025.map(
                (item) => item._id
              );
              json_db.poi_property_2025 = poi_property_2025_id;
            } else if (item === "demography_list") {
              let demography_list = [];
              const grid_id_list = get_grids_in_bounding_box_and_grouping({
                min_lat: min_lat_larger,
                min_long: min_long_larger,
                max_lat: max_lat_larger,
                max_long: max_long_larger,
                grouping_number,
              });

              const delay_milisecond_constant = 0;
              const delay_promise = () =>
                new Promise((res) =>
                  setTimeout(res, delay_milisecond_constant)
                );
              const child_function_demo = async (grid_list) => {
                return delay_promise().then(() => {
                  const core_function = async () => {
                    try {
                      const body = { grid_list };
                      const res = await axios.post(
                        bun_server + "/sini_v2/demography_list",
                        body,
                        config
                      );
                      const list_temp = res?.data || [];
                      if (list_temp.length > 0) {
                        demography_list = [...demography_list, ...list_temp];
                      }
                    } catch (error) {}
                  };
                  return core_function();
                });
              };
              const parent_function_demo = () => {
                return grid_id_list.reduce(
                  (last_promise, object) =>
                    last_promise.then((result_sum) =>
                      child_function_demo(object).then((result_current) => [
                        ...result_sum,
                        result_current,
                      ])
                    ),
                  Promise.resolve([])
                );
              };
              await parent_function_demo().then(async () => {
                try {
                  /*PROSES INTERSECT MULAI*/
                  const geometry_point = {
                    coordinates: [long, lat],
                    type: "Point",
                  };
                  const geojson_demography = {
                    type: "FeatureCollection",
                    features: [],
                  };
                  demography_list.forEach((item) => {
                    if (item.geometry.type === "MultiPolygon") {
                      item.geometry.type = "Polygon";
                      item.geometry.coordinates = item.geometry.coordinates[0];
                    }
                    if (item.geometry.type === "Polygon") {
                      geojson_demography.features.push(item);
                    }
                  });
                  const glookup = new geojson_geometries_lookup(
                    geojson_demography
                  );
                  const geojson_demography_text =
                    glookup.getContainers(geometry_point);
                  const properties_text =
                    geojson_demography_text?.features?.[0]?.properties || {};

                  let demography_intersect_list = [];
                  demography_list.forEach((feature_demography) => {
                    const geojson_process = {
                      type: "FeatureCollection",
                      features: [feature_demography, feature_isochrone],
                    };
                    let feature_result = intersect(geojson_process);
                    if (feature_result !== null) {
                      const area_demo_m2 = calculate_area(feature_demography);
                      const area_result_m2 = calculate_area(feature_result);
                      const proportional = area_result_m2 / area_demo_m2;
                      const proportional_simple = parseFloat(
                        (area_result_m2 / area_demo_m2).toFixed(4)
                      );
                      feature_result.properties.area_demo_m2 = area_demo_m2;
                      feature_result.properties.area_result_m2 = area_result_m2;
                      feature_result.properties.proportional =
                        proportional_simple;
                      const properties = feature_demography?.properties || {};
                      keys_interger.forEach((item) => {
                        const raw_value = properties?.[item] || 0;
                        feature_result.properties[item] =
                          proportional * raw_value;
                      });
                      keys_float.forEach((item) => {
                        const raw_value = properties?.[item] || 0;
                        feature_result.properties[item] =
                          proportional * raw_value;
                      });
                      feature_result.properties = {
                        ...feature_demography.properties,
                        ...feature_result.properties,
                      };
                      demography_intersect_list.push(feature_result);
                    }
                  });
                  let properties_number = {};

                  //summation
                  demography_intersect_list.forEach((feature) => {
                    keys_interger.forEach((item) => {
                      const init_number = properties_number?.[item] || 0;
                      const add_number = feature?.properties?.[item] || 0;
                      properties_number[item] = init_number + add_number;
                    });
                    keys_float.forEach((item) => {
                      const init_number = properties_number?.[item] || 0;
                      const add_number = feature?.properties?.[item] || 0;
                      properties_number[item] = init_number + add_number;
                    });
                  });

                  //pembualatan
                  keys_interger.forEach((item) => {
                    const init_number = properties_number?.[item] || 0;
                    properties_number[item] = Math.round(init_number);
                  });
                  keys_float.forEach((item) => {
                    const init_number = properties_number?.[item] || 0;
                    properties_number[item] = parseFloat(
                      init_number.toFixed(1)
                    );
                  });

                  const demography_properties = {
                    ...properties_text,
                    ...properties_number,
                  };
                  /*PROSES INTERSECT SELESAI*/

                  if (
                    demography_properties?.["KABKOT"] &&
                    demography_properties?.["PROVINSI"]
                  ) {
                    const KABKOT = demography_properties?.["KABKOT"];
                    const PROVINSI = demography_properties?.["PROVINSI"];
                    const res = await axios.get(
                      bun_server +
                        `/sini_v2/people_spending_by_city?KABKOT=${KABKOT}&PROVINSI=${PROVINSI}`,
                      config
                    );
                    const people_spending = res?.data || {};
                    dispatch({
                      type: "edit_inside_array_sini",
                      payload: {
                        key: "ai_parent_detail_list",
                        id_key_parent: "request_id",
                        id_value_parent: request_id,
                        id_key_child: "people_spending",
                        value_child: people_spending,
                      },
                    });
                    if (people_spending?._id) {
                      json_db.people_spending = people_spending._id;
                    }
                  }

                  const demography_list_id = demography_list.map(
                    (item) => item._id
                  );
                  json_db.demography_list = demography_list_id;
                  json_db.demography_intersect_list = demography_intersect_list;
                  json_db.demography_properties = demography_properties;

                  title_1 = demography_properties?.["DESA"] || "DESA";
                  title_2 = demography_properties?.["KABKOT"] || "KOTA";

                  dispatch({
                    type: "edit_inside_array_sini",
                    payload: {
                      key: "ai_parent_detail_list",
                      id_key_parent: "request_id",
                      id_value_parent: request_id,
                      id_key_child: "title_1",
                      value_child: title_1,
                    },
                  });

                  dispatch({
                    type: "edit_inside_array_sini",
                    payload: {
                      key: "ai_parent_detail_list",
                      id_key_parent: "request_id",
                      id_value_parent: request_id,
                      id_key_child: "title_2",
                      value_child: title_2,
                    },
                  });

                  dispatch({
                    type: "edit_inside_array_sini",
                    payload: {
                      key: "ai_parent_detail_list",
                      id_key_parent: "request_id",
                      id_value_parent: request_id,
                      id_key_child: "demography_list",
                      value_child: demography_list,
                    },
                  });
                  dispatch({
                    type: "edit_inside_array_sini",
                    payload: {
                      key: "ai_parent_detail_list",
                      id_key_parent: "request_id",
                      id_value_parent: request_id,
                      id_key_child: "demography_intersect_list",
                      value_child: demography_intersect_list,
                    },
                  });
                  dispatch({
                    type: "edit_inside_array_sini",
                    payload: {
                      key: "ai_parent_detail_list",
                      id_key_parent: "request_id",
                      id_value_parent: request_id,
                      id_key_child: "demography_properties",
                      value_child: demography_properties,
                    },
                  });
                } catch (error) {}
              });
            } else {
              /*
               min_lat: min_lat_larger,
                min_long: min_long_larger,
                max_lat: max_lat_larger,
                max_long: max_long_larger,
              */

              let min_long_final = min_long_small;
              let min_lat_final = min_lat_small;
              let max_long_final = max_long_small;
              let max_lat_final = max_lat_small;

              if (["flood", "landslide", "tsunami"].includes(item)) {
                min_long_final = min_long_larger;
                min_lat_final = min_lat_larger;
                max_long_final = max_long_larger;
                max_lat_final = max_lat_larger;
              }

              let link = item;
              const res = await axios.get(
                bun_server +
                  `/sini_v2/${link}?lat=${lat}&long=${long}&km_rad=${km_rad}&KABKOT=${KABKOT}&PROVINSI=${PROVINSI}&min_long=${min_long_final}&min_lat=${min_lat_final}&max_long=${max_long_final}&max_lat=${max_lat_final}`,
                config
              );
              const data = res?.data || {};

              //looping object response
              const item_object = [
                "people_spending",
                "landvalue_one",
                "landzone_one",
                "flood_one",
                "landslide_one",
                "tsunami_one",
                "rdtr_one",
              ];
              const item_array = [
                "landvalue_neighbor",
                "landzone_neighbor",
                "flood_neighbor",
                "landslide_neighbor",
                "tsunami_neighbor",
                "rdtr_neighbor",
                "poi_property_2025",
              ];
              for (const property in data) {
                //start
                const hazard_types = [
                  {
                    property_inside: "flood_neighbor",
                    list_key: "flood_intersect_list",
                  },
                  {
                    property_inside: "tsunami_neighbor",
                    list_key: "tsunami_intersect_list",
                  },
                  {
                    property_inside: "landslide_neighbor",
                    list_key: "landslide_intersect_list",
                  },
                ];

                hazard_types.forEach(({ property_inside, list_key }) => {
                  if (property === property_inside) {
                    const features_temp = data[property];
                    let intersect_list = [];
                    features_temp.forEach((feature_looping) => {
                      const geojson_process = {
                        type: "FeatureCollection",
                        features: [feature_looping, feature_isochrone],
                      };
                      let feature_result = intersect(geojson_process);
                      if (feature_result !== null) {
                        feature_result.properties = feature_looping.properties;
                        intersect_list.push(feature_result);
                      }
                    });
                    json_db[list_key] = intersect_list;
                    dispatch({
                      type: "edit_inside_array_sini",
                      payload: {
                        key: "ai_parent_detail_list",
                        id_key_parent: "request_id",
                        id_value_parent: request_id,
                        id_key_child: list_key,
                        value_child: intersect_list,
                      },
                    });
                  }
                });
                //end

                dispatch({
                  type: "edit_inside_array_sini",
                  payload: {
                    key: "ai_parent_detail_list",
                    id_key_parent: "request_id",
                    id_value_parent: request_id,
                    id_key_child: property,
                    value_child: data[property],
                  },
                });
                if (item_object.includes(property)) {
                  if (data?.[property]?._id) {
                    json_db[property] = data?.[property]?._id;
                  }
                } else if (item_array.includes(property)) {
                  if (data?.[property]?.length > 0) {
                    const array = data?.[property].map(
                      (element) => element?._id
                    );
                    json_db[property] = array;
                  }
                }
                sini_object[property] = data[property];
              }
              dispatch({
                type: "state_update",
              });
            }

            dispatch({
              type: "set_value_sini",
              payload: {
                key: "current_loading",
                value: item,
              },
            });
            dispatch({
              type: "clear_loading_action",
              payload: item,
            });
          } catch (error) {}
        };
        return core_function();
      });
    };

    await parent_function().then(async () => {
      try {
        const body = {
          request_id: request_id,
          json_db: json_db,
          lat,
          long,
          km_rad,
          title_1,
          title_2,
        };
        await axios.post(bun_server + "/sini_v2/save_sini", body, config);

        if (from === "ai_hbu") {
          dispatch({
            type: "sini_hbu_update",
          });
          let new_data = compress_sini(sini_object); //Copy object agar tidak merusak original
          const body_sini = {
            geo_layer_id,
            feature_key,
            field_key,
            json_ai: new_data,
          };
          const res_summary_sini = await axios.post(
            bun_server + `/sini_v2/ai_excel/generate_summary_sini`,
            body_sini,
            config
          );
          summary_sini = res_summary_sini?.data?.summary_sini;
          await axios.post(
            bun_server + `/sini_v2/ai_excel/update_summary_sini`,
            {
              request_id,
              summary_sini,
            },
            config
          );
          dispatch({
            type: "edit_inside_array_sini",
            payload: {
              key: "ai_parent_detail_list",
              id_key_parent: "request_id",
              id_value_parent: request_id,
              id_key_child: "summary_sini",
              value_child: summary_sini,
            },
          });
        }
        if (is_from_excel) {
          dispatch(
            create_ai_sini_sheet({
              geo_layer_id,
              feature_key,
              field_key,
              request_id,
              is_from_excel,
            })
          );
          dispatch({
            type: "set_value_sini",
            payload: {
              key: "sheet_object_selected",
              value: {
                geo_layer_id,
                feature_key,
                field_key,
                request_id,
                is_from_excel,
              },
            },
          });
        }
        dispatch({
          type: "set_value_sini",
          payload: {
            key: "request_id_loading",
            value: "",
          },
        });
        dispatch({
          type: "set_value_sini",
          payload: {
            key: "sini_choose_map_active",
            value: false,
          },
        });
        dispatch({
          type: "clear_loading_action",
          payload: "sini_load_parent",
        });
        dispatch(get_quota_access());
        dispatch(get_quota_access_sini_ai());
        dispatch(get_quota_ai_chat());
        dispatch({
          type: "set_value_sini",
          payload: {
            key: "coordinates_loading",
            value: null,
          },
        });
        dispatch({
          type: "state_update",
        });
      } catch (error) {}
    });
  } catch (error) {}
};
